// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .farmerTextField {
    background-color: "#FFFFFF";
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: left;
    background-color: white;

}

.farmerTextField ::-webkit-input-placeholder { 
    color:rgba(0, 0, 0, 0.87) !important;
    font-family: 'Roboto'!important;
    font-size: 16px!important;
    font-weight: 400!important;
    line-height: 24px!important;
    letter-spacing: 0.5px!important;
    text-align: left!important;
  }

.farmer-addbutton-container {
    text-align: end;
    align-self: center;
}

@media screen and (max-width: 900px) {
    .farmer-addbutton-container {
        padding-top: 10px;
        text-align: start;
    }
}

.farmerNoFilter{
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4000000059604645px;
    text-align: left;
    color: rgba(0, 0, 0, 0.6);
    
}

.gridActionCell{
    margin: 8px 14px 8px 14px!important;
    border-radius: 50px !important;
    font-family: 'Montserrat'!important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 14px !important;
}

.gridActionCellDetails{
    color: rgba(80, 175, 71, 1)!important;
    border: 1px solid rgba(80, 175, 71, 1) !important;

}
.gridActionCellEdit{
     color: rgba(251, 186, 0, 1)!important; 
     border: 1px solid rgba(251, 186, 0, 1)!important; 
}
.gridActionCellDelete{
    color: rgba(239, 0, 0, 1)!important;
    border: 1px solid rgba(239, 0, 0, 1)!important;
} */

.usersHeading{
    font-family: 'Montserrat';
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: 0em;
    color: #737D86;
    height: 30px;
    padding-bottom: 2rem;
}
.user-search-input{
    border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/User_Management/Users/Users.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkEG;;AAEH;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB","sourcesContent":["/* .farmerTextField {\n    background-color: \"#FFFFFF\";\n    font-family: 'Roboto';\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n    text-align: left;\n    background-color: white;\n\n}\n\n.farmerTextField ::-webkit-input-placeholder { \n    color:rgba(0, 0, 0, 0.87) !important;\n    font-family: 'Roboto'!important;\n    font-size: 16px!important;\n    font-weight: 400!important;\n    line-height: 24px!important;\n    letter-spacing: 0.5px!important;\n    text-align: left!important;\n  }\n\n.farmer-addbutton-container {\n    text-align: end;\n    align-self: center;\n}\n\n@media screen and (max-width: 900px) {\n    .farmer-addbutton-container {\n        padding-top: 10px;\n        text-align: start;\n    }\n}\n\n.farmerNoFilter{\n    font-family: 'Roboto';\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.4000000059604645px;\n    text-align: left;\n    color: rgba(0, 0, 0, 0.6);\n    \n}\n\n.gridActionCell{\n    margin: 8px 14px 8px 14px!important;\n    border-radius: 50px !important;\n    font-family: 'Montserrat'!important;\n    font-size: 14px !important;\n    font-weight: 700 !important;\n    line-height: 14px !important;\n}\n\n.gridActionCellDetails{\n    color: rgba(80, 175, 71, 1)!important;\n    border: 1px solid rgba(80, 175, 71, 1) !important;\n\n}\n.gridActionCellEdit{\n     color: rgba(251, 186, 0, 1)!important; \n     border: 1px solid rgba(251, 186, 0, 1)!important; \n}\n.gridActionCellDelete{\n    color: rgba(239, 0, 0, 1)!important;\n    border: 1px solid rgba(239, 0, 0, 1)!important;\n} */\n\n.usersHeading{\n    font-family: 'Montserrat';\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 30px;\n    letter-spacing: 0em;\n    color: #737D86;\n    height: 30px;\n    padding-bottom: 2rem;\n}\n.user-search-input{\n    border-radius: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
